/**
 *  Handles animations & lazy loading background images
 */

( function($){
    'use strict';

    /**
     * Lazy load background images
     */
    jQuery(document).ready(function($) {

        var isMobile = window.matchMedia('(max-width: 1024px)').matches;

        if (isMobile) {
            $('.job-card-wrap').removeClass('hidden');
            $('.job-card-wrap').removeClass('animate');
        }

        
        // Activate aniations on page load
        $(document).ready(function() {
            // Function to check if any element with a specific class is in the viewport
            function isElementInViewport(className, buffer) {
                var windowHeight = $(window).height();
                var $elements = $('.' + className);
                
                $elements.each(function() {
                    var $elem = $(this);
                    var elemTop = $elem.offset().top;
                    var elemBottom = elemTop + $elem.outerHeight();
    
                    // Add buffer value to the top and subtract from the bottom
                    elemTop -= buffer;
                    elemBottom += buffer;
        
                    if ((elemTop >= 0 && elemTop < windowHeight) ||
                        (elemBottom >= 0 && elemBottom < windowHeight)) {
                        $(this).removeClass('hidden');
                    }
                });
            }
        
            // Check if any element with the class "animate" is in the viewport
            isElementInViewport('animate', 300);
    
            //Remove class from first block
    
            $('.block').each(function(index){
                if (index === 0) {
                    $(this).find('.hidden').removeClass('hidden');
                }
            });

            $(document).on('facetwp-loaded', function() {
                $(window).trigger('scroll');
            });

            $(window).trigger('scroll');
        });
    
        // Activate animations on scroll
        $(window).scroll(function() {
            var windowHeight = $(window).height();
            var scrollPosition = $(window).scrollTop();
    
            $('.animate').each(function() {
                var offset = $(this).offset().top;
    
                if (scrollPosition > offset - windowHeight + 0) { // Adjusted offset for earlier trigger
                    $(this).removeClass('hidden');
                    $(this).siblings().removeClass('hidden');
                }
            });
    
        }); 

        // Smooth scroll on anchor tags
        $('a[href^="#"]').on('click', function (e) {
            var hash = $(this).attr('href');

            if (hash !== "#" && hash !== "#accessibility") {
                e.preventDefault();

                // Adjust offset depending on screen width
                var windowWidth = $(window).width();
                var scrollOffset = windowWidth < 2000 ? 100 : 130;

                $('html, body').animate({
                    scrollTop: $(hash).offset().top - scrollOffset
                }, 500, function() {
                    // Optional: update active section after animation
                    if (typeof updateActiveSection === 'function') {
                        updateActiveSection();
                    }
                });
            }
        });

    });
    
} )();